import createCardListingView from '../Views/createCardListingView';
import FlexCourseCard from './FlexCourseCard';

export default createCardListingView(FlexCourseCard, {
  displayName: 'CourseListingView',
});
